import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const loanHistorySearchModel = (patronId = "", itemName = "", shippingLocationId = "", studentId = "", districtId = "", organization = "") => {
    return Object.assign({}, searchModel(patronId.toString(), "title", false, "title"), {
        itemName,
        patronId,
        shippingLocationId,
        studentId,
        districtId,
        organization,
        ClearLoanHistorySearch: clearLoanHistorySearch,
        ApplySorting: applySorting,
    });
};

function clearLoanHistorySearch(this: Record<string, unknown>) {
    this.itemName = "";
    this.patronId = "";
    this.shippingLocationId = "";
    this.studentId = "";
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(loanHistorySearchCriteria: Record<string, any>, loanHistory: Record<string, any>[]) {
    if (isNullOrUndefined(loanHistory) || isArrayNullOrEmpty(loanHistory))
        return loanHistory;

    return loanHistory.sort(dynamicSort(loanHistorySearchCriteria.sortByColumn as string, loanHistorySearchCriteria.sortDescending as boolean));
}
